import { useMemo } from "react";
import { Link } from "react-router-dom";
import { HOUSE_CREATIVES } from "./adsConfig";

interface Props {
  minHeight: number;
  /** Pro deterministickou rotaci napříč rerendery v rámci jedné stránky */
  seed?: string;
}

export function HouseAd({ minHeight, seed }: Props) {
  const creative = useMemo(() => {
    if (HOUSE_CREATIVES.length === 0) return null;
    const idx = seed
      ? Math.abs(hash(seed)) % HOUSE_CREATIVES.length
      : Math.floor(Math.random() * HOUSE_CREATIVES.length);
    return HOUSE_CREATIVES[idx];
  }, [seed]);

  if (!creative) return null;

  const content = (
    <div
      className="rounded-xl border border-primary/20 bg-gradient-to-br from-primary/5 to-accent/5 p-5 transition hover:shadow-elevated"
      style={{ minHeight }}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="font-semibold text-base">{creative.title}</h3>
        {creative.sponsored && (
          <span className="text-[10px] uppercase tracking-wider text-muted-foreground border border-border rounded px-1.5 py-0.5">
            Sponzor
          </span>
        )}
      </div>
      <p className="text-sm text-muted-foreground mb-4">{creative.body}</p>
      <span className="inline-flex items-center text-sm font-semibold text-primary">
        {creative.cta} →
      </span>
    </div>
  );

  if (creative.external) {
    return (
      <a
        href={creative.href}
        target="_blank"
        rel="sponsored noopener noreferrer"
        className="block"
      >
        {content}
      </a>
    );
  }
  return (
    <Link to={creative.href} className="block">
      {content}
    </Link>
  );
}

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return h;
}
